import { render, staticRenderFns } from "./tenancy-status.vue?vue&type=template&id=d69a7d2c&scoped=true&"
import script from "./tenancy-status.vue?vue&type=script&lang=js&"
export * from "./tenancy-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d69a7d2c",
  null
  
)

export default component.exports